/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_View_AllInputs */

const en_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all`)
};

const de_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle anzeigen`)
};

const es_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todo`)
};

const fr_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout afficher`)
};

const nl_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles bekijken`)
};

const it_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza tutto`)
};

const pt_br2_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver tudo`)
};

const pl_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wszystko`)
};

const hu_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes megtekintése`)
};

const ro_admin_dashboard_view_all = /** @type {(inputs: Admin_Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi toate`)
};

/**
* | output |
* | --- |
* | "View all" |
*
* @param {Admin_Dashboard_View_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_view_all = /** @type {((inputs?: Admin_Dashboard_View_AllInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_View_AllInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_view_all(inputs)
	if (locale === "de") return de_admin_dashboard_view_all(inputs)
	if (locale === "es") return es_admin_dashboard_view_all(inputs)
	if (locale === "fr") return fr_admin_dashboard_view_all(inputs)
	if (locale === "nl") return nl_admin_dashboard_view_all(inputs)
	if (locale === "it") return it_admin_dashboard_view_all(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_view_all(inputs)
	if (locale === "pl") return pl_admin_dashboard_view_all(inputs)
	if (locale === "hu") return hu_admin_dashboard_view_all(inputs)
	return ro_admin_dashboard_view_all(inputs)
});
export { admin_dashboard_view_all as "admin.dashboard.view_all" }